<template>
  <div>
    <div class="d-flex align-items-center gap-lg-1 ai_answer mb-3">
      <div class="bg-white rounded-circle p-2 custom_box_shadow sparks_icon">
        <!-- <AssistantIcon :height="32" :width="32" :chat-theme-settings="chatThemeSettings" /> -->
        <Sparks fHeight="24" width="24" :isPrimeColor="true" />
      </div>
      <!-- <div>
        <span class="horizontal_border"></span>
      </div> -->
      <div>
        <p class="mb-1 _dynamic_text_color" :style="{ color: textColor }">
          <small>{{ clientName }}</small>
        </p>
        <div class="ai_answer_text custom_box_shadow">
          <p v-if="fullFillMentText" class="mb-0">
            {{
              fullFillMentText
            }}
          </p>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import AssistantIcon from '../icons/AssistantIcon.vue';
// import AiVehicleInfo from './AiVehicleInfo.vue';

import Sparks from '../icons/Sparks.vue';


export default {
  components: {
    // AiVehicleInfo,
    AssistantIcon,
    // AiCoupons
    Sparks,
  },
  props: {
    fullFillMentText: {
      default: '',
      required: false,
    },
    requesttime: {
      default: '',
      required: false,
    },
    index: {
      default: '',
      required: false,
    },
    chatThemeSettings: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      clientName: window.clientName,
      textColor: '#000'
    };
  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },
  mounted() {
    if (this.isGradient) {
      this.textColor = '#fff';
    }
  }
}
</script>
<style>
.ai_answer_text {
  background: #ffffff;
  padding: 15px 20px;
  border-radius: 10px;
  width: fit-content;
  max-width: 500px;
}

.horizontal_border {
  height: 1.5rem;
  width: 1px;
  background: #66666674;
  display: block;
}

.ai_answer p {
  font-weight: 500;
}

.gap-lg-1 {
  gap: 10px;
}

.sparks_icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
